import React, { FC, useContext, useEffect, useState } from 'react'
import * as pageUtils from './__index.utils'
import PaymentPage from '@components/ui/paymentPage'
import { AppStateContext } from '@components/layouts/DynamicLayout'
import { ButtonLink } from '@components/ui/ButtonLink'
import Invoice from '@components/ui/invoice'
import { IInvoice } from '@services/types/invoice'
import { navigate } from 'gatsby'
import apiClient from '@services/api.client'
import { Payments } from '@services/models/payment.model'
import { joinClasses } from '@utils/styles'
import Loader from '@components/ui/loader'
// import { RealexHpp } from '../../../../static/rxp-js'
import axios from 'axios'
import { pushEvent } from '@utils/tracking'

type PaymentProps = {}

type stateType = {
	invoice: IInvoice
	origin: string
}

declare global {
	interface Window {
		RealexHpp: any
	}
}

const Payment: FC<PaymentProps> = ({}) => {
	const payments = new Payments()
	const { pageData } = useContext(AppStateContext)
	const [invoice, setInvoice] = useState<IInvoice>({} as IInvoice)
	const [requestOrigin, setRequestOrigin] = useState<string>()
	const [message, setMessage] = useState<string>()
	const [isLoading, setIsLoading] = useState<boolean>(false)

	useEffect(() => {
		const state = window.history.state as stateType

		if (state?.invoice) {
			setInvoice(state.invoice)
			setRequestOrigin(state?.origin)
		} else if (state?.origin) {
			navigate(state.origin)
		} else {
			navigate('/')
		}
	}, [])

	const paymentUnsuccessfulRedirect = (code?: string) => {
		if (requestOrigin)
			navigate(requestOrigin, {
				state: {
					isPaymentSuccessful: false,
					code
				}
			})
	}

	const trackPaymentServiceEnd = () => {
		pushEvent('service_end', {
			service_name: 'payment_request',
			destination_site: 'payment_gateway'
		})
	}

	const success = async (response: pageUtils.HPPAnswer, transactionId: string) => {
        if (!transactionId) throw new Error('Transaction ID is missing for payment response.');

		await payments
			.sendPaymentResponse(encodeJsonToBase64(response), transactionId)
			.then((res) => {
				trackPaymentServiceEnd()
				if (requestOrigin) {
					navigate(requestOrigin, {
						state: {
							isPaymentSuccessful: true
						}
					})
				} else {
					paymentUnsuccessfulRedirect()
				}
			})
			.catch((error) => {
				console.error(error)
				paymentUnsuccessfulRedirect()
			})
	}

	// Charger le script dynamiquement
	const loadScript = () => {
		return new Promise<void>((resolve, reject) => {
			if (window.RealexHpp) return resolve() // déjà chargé
			const script = document.createElement('script')
			script.src = '/rxp-js.js' // chemin depuis /public
			script.async = true
			script.onload = () => resolve()
			script.onerror = () => reject(new Error('Failed to load rxp-js'))
			document.body.appendChild(script)
		})
	}

	const fetchPayments = async () => {
		setIsLoading(true)

		await payments
			.getPaymentHPPReponse(invoice.id)
			.then((res: { id: string, token: string }) => {
				// Reference for integrating GP
				// https://github.com/globalpayments/rxp-js/blob/master/examples/hpp/process-a-payment-embedded-autoload-callback.html
				const RealexHpp = window.RealexHpp
				RealexHpp.setHppUrl(process.env.PAYMENT_URL)
				RealexHpp.embedded.init(
					pageUtils.BUTTON_ID,
					pageUtils.IFRAME_ID,
					function (answer: pageUtils.HPPAnswer, close: () => void) {
						close()
						if (answer.AUTHCODE) {
							setMessage('Processing transaction')
							//success
							success(answer, res.id)
						} else {
							// redirects to the detail page
							paymentUnsuccessfulRedirect(answer.RESULT)
						}
					},
                    decodeBase64ToJson(res.token)
				)
				setTimeout(() => {
					setIsLoading(false)
				}, 2100)
			})
			.catch((err) => {
				console.error('Error fetching payment response', err)

				paymentUnsuccessfulRedirect()
			})
	}

	useEffect(() => {
		if (invoice.id) {
			loadScript()
				.then(() => {
					fetchPayments()
				})
				.catch((err) => {
					console.error('Error loading payment script', err)
					paymentUnsuccessfulRedirect()
				})
		}
	}, [invoice.id])

	return (
		<>
			<div
				className={joinClasses([
					pageUtils.classes.container,
					pageUtils.classes.centerItem
				])}
			>
				{isLoading && <Loader text={pageData.assets?.loading} />}
				{!message && (
					<div
						className={joinClasses([
							pageUtils.classes.row,
							isLoading ? pageUtils.classes.visibility : ''
						])}
					>
						<div className={pageUtils.classes.billFormContainer}>
							{/* <PaymentPage /> */}
							<iframe
								id={pageUtils.IFRAME_ID}
								style={{ display: 'none' }}
							></iframe>
						</div>
						<div className={pageUtils.classes.invoiceContainer}>
							<h4>{pageData?.assets?.paymentPage_fees_to_pay}</h4>
							<Invoice invoice={invoice} />
							{/* <ButtonLink
								type="button"
								onclick={payInvoice}
								wrapperClassName={pageUtils.classes.buttonWrapper}
								text={pageData?.assets?.paymentPage_submit_and_pay}
							/> */}
						</div>
					</div>
				)}

				{message && (
					<>
						<div>{message}</div>
					</>
				)}
			</div>
		</>
	)
}

function encodeJsonToBase64(response: any) {
  return btoa(JSON.stringify(response));
}

function decodeBase64ToJson(base64: string): any {
  const binaryString = atob(base64);
  const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
  const jsonString = new TextDecoder().decode(byteArray);
  return JSON.parse(jsonString);
}

export default Payment
